import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';

export async function addPlanToGroup(groupId: string, planId: string): Promise<void> {
  await db.setDoc(db.doc(firestore, 'groups', groupId, 'plans', planId), {
    createdAt: db.serverTimestamp(),
  });
}

export async function deletePlanFromGroup(groupId: string, planId: string): Promise<void> {
  await db.deleteDoc(db.doc(firestore, 'groups', groupId, 'plans', planId));
}

export async function addPlanToGroups(groupIds: string[], planId: string): Promise<void> {
  const promises = [];
  for (const groupId of groupIds) {
    promises.push(addPlanToGroup(groupId, planId));
  }
  await Promise.all(promises);
}

export async function deletePlanFromGroups(groupIds: string[], planId: string): Promise<void> {
  const promises = [];
  for (const groupId of groupIds) {
    promises.push(deletePlanFromGroup(groupId, planId));
  }
  await Promise.all(promises);
}

export async function getGroupPlanIds(groupId: string) {
  const snapshot = await db.getDocs(db.collection(firestore, 'groups', groupId, 'plans'));
  return snapshot.docs.map((doc) => doc.id);
}
